import { useState, useEffect, useRef } from 'react'

const useContainerWidth = () => {
  const [width, setWidth] = useState(0)
  const containerRef = useRef(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const resizeObserver = new ResizeObserver((entries) => {
      const { width } = entries[0].contentRect
      setWidth(width)
    })

    resizeObserver.observe(container)

    return () => {
      resizeObserver.unobserve(container)
    }
  }, [])

  return { containerRef, width }
}

export default useContainerWidth
